import React, { useState } from 'react';

export default function DetailSection({ title, defaultOpen = true, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="ro-detail-section">
      <button className="ro-detail-header" onClick={() => setOpen(o => !o)}>
        <span className="ro-detail-title">{title}</span>
        <span className="ro-detail-chevron">{open ? '▾' : '▸'}</span>
      </button>
      {open && <div className="ro-detail-body">{children}</div>}
    </div>
  );
}
